import { ProductCode, Product } from './types';

export const DBT_ALT_COINS_PRODUCT_CODES = ['OS', 'SF', 'MT', 'MA', 'RP', 'RF', 'HF'];
export const PRODUCT_CODES = [
  // Deribit
  'DO',
  'EH',
  'CF',
  'AZ',
  'SL',
  'SO',
  'OS',
  'SF',
  'MT',
  'MA',
  'RP',
  'RF',
  'HF',
  'BU',
  'EU',
  'AX',
  'TR',
  'HU',
  // Bit.com
  'BO',
  'VT',
  'OJ',
  'GD',
  'BF',
  'ZW',
  'HM',
  'AU',
  // Bybit
  'JB',
  'BE',
  'JC',
  'BX',
  'BB',
  'EF',
  'EO',
  'XR',
  // --- BEGIN GENERATED PRODUCT CONFIG (paradex-codes) ---
  'XA',
  'XB',
  'XC',
  'XD',
  'XE',
  'XF',
  'XG',
  'XH',
  'XI',
  'XJ',
  'XK',
  'XL',
  'XM',
  'XN',
  'XO',
  'XP',
  'XQ',
  'XS',
  'XT',
  'XU',
  'XV',
  'XW',
  'XX',
  'XY',
  'XZ',
  'ZA',
  'ZB',
  'ZC',
  'ZD',
  'ZE',
  'ZF',
  'ZG',
  'ZH',
  'ZI',
  'ZJ',
  'AE',
  'ZK',
  'ZL',
  'ZM',
  'ZN',
  'ZO',
  'ZP',
  'ZQ',
  'ZR',
  'ZS',
  'ZT',
  'ZU',
  'ZV',
  'ZX',
  'ZY',
  'ZZ',
  'AA',
  'AF',
  'AC',
  'AD',
  'YA',
  'YB',
  'YC',
  'YD',
  'BA',
  'BC',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BK',
  'BL',
  'BM',
  'BN',
  'BP',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'CA',
  'CB',
  'CD',
  'CE',
  'CG',
  'CH',
  'CI',
  'CJ',
  'CK',
  'CM',
  'CN',
  'CO',
  // --- END GENERATED PRODUCT CONFIG (paradex-codes) ---
];

export const PRODUCTS_STRICT: {
  [Code in ProductCode]: Product<Code>;
} = {
  // Deribit
  DO: {
    code: 'DO',
    venue: 'DBT',
    kind: 'OPTION',
    currency: 'BTC',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BTC Option European - DBT',
    longName: 'DO - BTC Option - European - Deribit',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'BTC',
    minBlockSize: 25,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
  },
  EH: {
    code: 'EH',
    venue: 'DBT',
    kind: 'OPTION',
    currency: 'ETH',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'ETH Option European - DBT',
    longName: 'EH - ETH Option - European - Deribit',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'ETH',
    minBlockSize: 250,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
  },
  CF: {
    code: 'CF',
    venue: 'DBT',
    kind: 'FUTURE',
    currency: 'BTC',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BTC Future Inverse - DBT',
    longName: 'CF - BTC Future - Inverse - Deribit',
    contractSize: 10,
    contractCurrency: 'USD',
    quoteCurrency: 'USD',
    minBlockSize: 20_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
  },
  AZ: {
    code: 'AZ',
    venue: 'DBT',
    kind: 'FUTURE',
    currency: 'ETH',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'ETH Future Inverse - DBT',
    longName: 'AZ - ETH Future - Inverse - Deribit',
    contractSize: 1,
    contractCurrency: 'USD',
    quoteCurrency: 'USD',
    minBlockSize: 100_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
  },
  SL: {
    code: 'SL',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'SL - SOL Option - European - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'SOL Option European - DBT',
    kind: 'OPTION',
    minBlockSize: 2_500,
    strategies: 'all',
    contractCurrency: 'SOL',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 1,
    ratioPrecision: 1,
    pricePrecision: 3,
    isDisabled: true,
  },
  SO: {
    code: 'SO',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'SO - SOL Future - Inverse - Deribit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'SOL Future Inverse - DBT',
    kind: 'FUTURE',
    minBlockSize: 20_000,
    strategies: 'all',
    contractCurrency: 'USD',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    ratioPrecision: 2,
    pricePrecision: 2,
    isDisabled: true,
  },
  OS: {
    code: 'OS',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'OS - SOL Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'SOL Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    contractCurrency: 'SOL',
    quoteCurrency: 'USDC',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    ratioPrecision: 1,
    pricePrecision: 1,
    minBlockSize: 1,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: false, // SF (SOL linear future) integrated as hedge counterpart
  },
  MT: {
    code: 'MT',
    venue: 'DBT',
    currency: 'MATIC',
    longName: 'MT - MATIC Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'MATIC Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    contractCurrency: 'MATIC',
    quoteCurrency: 'USDC',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 1000,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 1,
    isDisabled: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  RP: {
    code: 'RP',
    venue: 'DBT',
    currency: 'XRP',
    longName: 'RP - XRP Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'XRP Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'XRP',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 1000,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 1,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: false, // RF (XRP linear future) integrated as hedge counterpart
  },
  SF: {
    code: 'SF',
    venue: 'DBT',
    currency: 'SOL',
    longName: 'SF - SOL Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SOL Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 50_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'SOL',
    minContractIncrement: 1,
    quantityPrecision: 1,
    contractSize: 0.1,
    datedContractSize: 0.01, // dated SOL futures size 0.01 vs perp 0.1
    datedQuantityPrecision: 2, // dated SOL 0.01 needs 2 dp vs perp 0.1's 1 dp
    ratioPrecision: 2,
    pricePrecision: 3,
    isDisabledForOb: true, // not tradable on OB (SOL not enabled for DBT)
  },
  MA: {
    code: 'MA',
    venue: 'DBT',
    currency: 'MATIC',
    longName: 'MA - MATIC Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'MATIC Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 200_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'MATIC',
    minContractIncrement: 1,
    quantityPrecision: 2,
    contractSize: 10,
    ratioPrecision: 2,
    pricePrecision: 4,
    isDisabled: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
    isPerpStrategyLegDisabled: true,
  },
  RF: {
    code: 'RF',
    venue: 'DBT',
    currency: 'XRP',
    longName: 'RF - XRP Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XRP Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 50_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'XRP',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    datedContractSize: 1, // dated XRP futures size 1 vs perp 10
    ratioPrecision: 2,
    pricePrecision: 4,
    isDisabledForOb: true, // not tradable on OB (XRP not enabled for DBT)
  },
  HF: {
    code: 'HF',
    venue: 'DBT',
    currency: 'HYPE',
    longName: 'HF - HYPE Future - Linear - Deribit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'HYPE Future Linear - DBT',
    kind: 'FUTURE',
    minBlockSize: 50_000,
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'HYPE',
    minContractIncrement: 1,
    quantityPrecision: 1,
    contractSize: 0.1,
    ratioPrecision: 2,
    pricePrecision: 3,
    isDisabledForOb: true, // not tradable on OB
  },
  // Deribit USDC linear options (BTC, ETH, AVAX, TRX)
  BU: {
    code: 'BU',
    venue: 'DBT',
    currency: 'BTC',
    longName: 'BU - BTC Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'BTC',
    minContractIncrement: 0.01,
    quantityPrecision: 2,
    contractSize: 1,
    ratioPrecision: 1,
    pricePrecision: 0,
    minBlockSize: 25,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  EU: {
    code: 'EU',
    venue: 'DBT',
    currency: 'ETH',
    longName: 'EU - ETH Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'ETH',
    minContractIncrement: 0.1,
    quantityPrecision: 1,
    contractSize: 1,
    ratioPrecision: 1,
    pricePrecision: 1,
    minBlockSize: 250,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  AX: {
    code: 'AX',
    venue: 'DBT',
    currency: 'AVAX',
    longName: 'AX - AVAX Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'AVAX Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'AVAX',
    minContractIncrement: 100,
    quantityPrecision: 0,
    contractSize: 100,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 2500,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  TR: {
    code: 'TR',
    venue: 'DBT',
    currency: 'TRX',
    longName: 'TR - TRX Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'TRX Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'TRX',
    minContractIncrement: 10000,
    quantityPrecision: 0,
    contractSize: 10000,
    ratioPrecision: 1,
    pricePrecision: 4,
    minBlockSize: 250000,
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  HU: {
    code: 'HU',
    venue: 'DBT',
    currency: 'HYPE',
    longName: 'HU - HYPE Option - European - Linear - Deribit',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'HYPE Option Linear - DBT',
    kind: 'OPTION',
    strategies: 'all',
    quoteCurrency: 'USDC',
    contractCurrency: 'HYPE',
    minContractIncrement: 1,
    quantityPrecision: 0,
    contractSize: 10,
    ratioPrecision: 1,
    pricePrecision: 3,
    minBlockSize: 1500, // Deribit block_trade_min_trade_amount, in base coin (HYPE)
    isDisabled: false,
    isDisabledForOb: true,
    isHedgeDisabled: false, // HF (HYPE linear perp) integrated as hedge counterpart
  },
  // Bit.com
  GD: {
    code: 'GD',
    currency: 'BCH',
    longName: 'GD - BCH Option - European - Inverse - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BCH Option European Inverse - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'BCH',
    minBlockSize: 100,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    quoteCurrency: 'BCH',
    isDisabled: true,
  },
  BO: {
    code: 'BO',
    currency: 'BTC',
    longName: 'BO - BTC Option - European - Inverse - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BTC Option European Inverse - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'BTC',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    quoteCurrency: 'BTC',
    isDisabled: true,
  },
  VT: {
    code: 'VT',
    currency: 'ETH',
    longName: 'VT - ETH Option - European - Inverse - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'ETH Option European Inverse - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'ETH',
    minBlockSize: 20,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    quoteCurrency: 'ETH',
    isDisabled: true,
  },
  OJ: {
    code: 'OJ',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'TON',
    longName: 'OJ - TON Option - European - Linear - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'TON Option European Linear - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractCurrency: 'TON',
    strategies: 'all',
    contractSize: 1,
    minBlockSize: 1,
    pricePrecision: 4,
    ratioPrecision: 2,
    quantityPrecision: 0,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  HM: {
    code: 'HM',
    currency: 'BCH',
    longName: 'HM - BCH Future - Inverse - Bit.com',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BCH Future Inverse - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 5_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  BF: {
    code: 'BF',
    currency: 'BTC',
    longName: 'BF - BTC Future - Inverse - Bit.com',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BTC Future Inverse - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 10,
    contractCurrency: 'USD',
    minBlockSize: 500,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  ZW: {
    code: 'ZW',
    currency: 'ETH',
    longName: 'ZW - ETH Future - Inverse - Bit.com',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'ETH Future Inverse - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 5_000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  BD: {
    code: 'BD',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'BTC',
    longName: 'BD - BTC Option - European - Linear - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option European Linear - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    contractSize: 1,
    contractCurrency: 'BTC',
    strategies: 'all',
    minContractIncrement: 0.01,
    minBlockSize: 0.01,
    pricePrecision: 0,
    quantityPrecision: 2,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  WV: {
    code: 'WV',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'ETH',
    longName: 'WV - ETH Option - European - Linear - Bit.com',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option European Linear - BIT',
    venue: 'BIT',
    kind: 'OPTION',
    strategies: 'all',
    contractSize: 1,
    contractCurrency: 'ETH',
    minContractIncrement: 0.1,
    minBlockSize: 0.1,
    quantityPrecision: 1,
    pricePrecision: 0,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  PE: {
    code: 'PE',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'BTC',
    longName: 'PE - BTC Future - Linear - Bit.com',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'BTC',
    strategies: 'all',
    minContractIncrement: 0.01,
    minBlockSize: 0.01,
    quantityPrecision: 2,
    pricePrecision: 1,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  DE: {
    code: 'DE',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'ETH',
    longName: 'DE - ETH Future - Linear - Bit.com',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ETH Future Linear - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'ETH',
    strategies: 'all',
    minContractIncrement: 0.1,
    minBlockSize: 0.1,
    pricePrecision: 2,
    quantityPrecision: 1,
    ratioPrecision: 1,
    quoteCurrency: 'USD',
  },
  AU: {
    code: 'AU',
    isDisabled: true, // Bit.com deprecated: no discovery/marketdata connectivity
    currency: 'TON',
    longName: 'AU - TON Future - Linear - Bit.com',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'TON Future Linear - BIT',
    venue: 'BIT',
    kind: 'FUTURE',
    contractCurrency: 'TON',
    strategies: 'all',
    contractSize: 1,
    minBlockSize: 1,
    pricePrecision: 3,
    ratioPrecision: 2,
    quantityPrecision: 0,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  // Bybit
  BE: {
    code: 'BE',
    isDisabled: true, // Bybit inverse options have no discovery job; never populate
    currency: 'BTC',
    longName: 'BE - BTC Option - European - ByBit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'BTC Option European - BYB',
    venue: 'BYB',
    kind: 'OPTION',
    contractCurrency: 'BTC',
    strategies: 'all',
    isHedgeDisabled: true,
    contractSize: 1,
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    minBlockSize: 0.01,
    quoteCurrency: 'USDC',
  },
  JB: {
    code: 'JB',
    currency: 'SOL',
    longName: 'JB - SOL Option - European - ByBit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'SOL Option European - BYB',
    venue: 'BYB',
    kind: 'OPTION',
    contractCurrency: 'SOL',
    strategies: 'all',
    isHedgeDisabled: true,
    contractSize: 1,
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 1,
    minBlockSize: 1,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  JC: {
    code: 'JC',
    isDisabled: true, // Bybit inverse options have no discovery job; never populate
    currency: 'ETH',
    longName: 'JC - ETH Option - European - ByBit',
    contractType: 'EUROPEAN',
    marginType: 'INVERSE',
    shortName: 'ETH Option European - BYB',
    venue: 'BYB',
    kind: 'OPTION',
    contractCurrency: 'ETH',
    strategies: 'all',
    isHedgeDisabled: true,
    contractSize: 1,
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    minBlockSize: 0.1,
    quoteCurrency: 'USDC',
  },
  BX: {
    code: 'BX',
    currency: 'BTC',
    longName: 'BX - BTC Future - Linear - ByBit',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'BTC',
    minBlockSize: 0.001,
    minContractIncrement: 0.001,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 2,
    quoteCurrency: 'USD',
    isDisabled: true,
  },
  BB: {
    code: 'BB',
    currency: 'BTC',
    longName: 'BB - BTC Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'BTC Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  EF: {
    code: 'EF',
    currency: 'ETH',
    longName: 'EF - ETH Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'ETH Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 2,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  EO: {
    code: 'EO',
    currency: 'EOS',
    longName: 'EO - EOS Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'EOS Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: ['Future'],
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  XR: {
    code: 'XR',
    currency: 'XRP',
    longName: 'XR - XRP Future - Inverse - ByBit',
    contractType: 'INVERSE',
    marginType: 'INVERSE',
    shortName: 'XRP Future Inverse - BYB',
    venue: 'BYB',
    kind: 'FUTURE',
    contractSize: 1,
    contractCurrency: 'USD',
    minBlockSize: 1,
    strategies: ['Future'],
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 2,
    minContractIncrement: 1,
    quoteCurrency: 'USD',
  },
  // --- BEGIN GENERATED PRODUCT CONFIG (paradex-products) ---
  XA: {
    code: 'XA',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'BTC',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option Linear - PRDX',
    longName: 'XA - BTC Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.001,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
  },
  XB: {
    code: 'XB',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'ETH',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option Linear - PRDX',
    longName: 'XB - ETH Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.1,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
  },
  XC: {
    code: 'XC',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BTC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - PRDX',
    longName: 'XC - BTC Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.0001,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.0001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XD: {
    code: 'XD',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ETH',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ETH Future Linear - PRDX',
    longName: 'XD - ETH Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.01,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.0001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XE: {
    code: 'XE',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'HYPE',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'HYPE Option Linear - PRDX',
    longName: 'XE - HYPE Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'HYPE',
    quoteCurrency: 'USDC',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
  },
  XF: {
    code: 'XF',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'HYPE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'HYPE Future Linear - PRDX',
    longName: 'XF - HYPE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'HYPE',
    quoteCurrency: 'USDC',
    minBlockSize: 0.5,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XG: {
    code: 'XG',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'SOL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SOL Future Linear - PRDX',
    longName: 'XG - SOL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'SOL',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XH: {
    code: 'XH',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XAG',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XAG Future Linear - PRDX',
    longName: 'XH - XAG Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XAG',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XI: {
    code: 'XI',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'CL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'CL Future Linear - PRDX',
    longName: 'XI - CL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'CL',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XJ: {
    code: 'XJ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BNB',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BNB Future Linear - PRDX',
    longName: 'XJ - BNB Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BNB',
    quoteCurrency: 'USDC',
    minBlockSize: 0.02,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XK: {
    code: 'XK',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PAXG',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PAXG Future Linear - PRDX',
    longName: 'XK - PAXG Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PAXG',
    quoteCurrency: 'USDC',
    minBlockSize: 0.003,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XL: {
    code: 'XL',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XRP',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XRP Future Linear - PRDX',
    longName: 'XL - XRP Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XRP',
    quoteCurrency: 'USDC',
    minBlockSize: 10,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XM: {
    code: 'XM',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ZEC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ZEC Future Linear - PRDX',
    longName: 'XM - ZEC Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ZEC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.03,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XN: {
    code: 'XN',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LIT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LIT Future Linear - PRDX',
    longName: 'XN - LIT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LIT',
    quoteCurrency: 'USDC',
    minBlockSize: 10,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XO: {
    code: 'XO',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ADA',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ADA Future Linear - PRDX',
    longName: 'XO - ADA Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ADA',
    quoteCurrency: 'USDC',
    minBlockSize: 65,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XP: {
    code: 'XP',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'NEAR',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'NEAR Future Linear - PRDX',
    longName: 'XP - NEAR Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'NEAR',
    quoteCurrency: 'USDC',
    minBlockSize: 5,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XQ: {
    code: 'XQ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XPT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XPT Future Linear - PRDX',
    longName: 'XQ - XPT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XPT',
    quoteCurrency: 'USDC',
    minBlockSize: 0.006,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XS: {
    code: 'XS',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XCU',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XCU Future Linear - PRDX',
    longName: 'XS - XCU Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XCU',
    quoteCurrency: 'USDC',
    minBlockSize: 2,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XT: {
    code: 'XT',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BZ',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BZ Future Linear - PRDX',
    longName: 'XT - BZ Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BZ',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XU: {
    code: 'XU',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'SUI',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SUI Future Linear - PRDX',
    longName: 'XU - SUI Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'SUI',
    quoteCurrency: 'USDC',
    minBlockSize: 15,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XV: {
    code: 'XV',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LINK',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LINK Future Linear - PRDX',
    longName: 'XV - LINK Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LINK',
    quoteCurrency: 'USDC',
    minBlockSize: 1.5,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XW: {
    code: 'XW',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'TAO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'TAO Future Linear - PRDX',
    longName: 'XW - TAO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'TAO',
    quoteCurrency: 'USDC',
    minBlockSize: 0.05,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XX: {
    code: 'XX',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ASTER',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ASTER Future Linear - PRDX',
    longName: 'XX - ASTER Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ASTER',
    quoteCurrency: 'USDC',
    minBlockSize: 20,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XY: {
    code: 'XY',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PENDLE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PENDLE Future Linear - PRDX',
    longName: 'XY - PENDLE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PENDLE',
    quoteCurrency: 'USDC',
    minBlockSize: 10,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  XZ: {
    code: 'XZ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'WLFI',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'WLFI Future Linear - PRDX',
    longName: 'XZ - WLFI Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'WLFI',
    quoteCurrency: 'USDC',
    minBlockSize: 200,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZA: {
    code: 'ZA',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PYTH',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PYTH Future Linear - PRDX',
    longName: 'ZA - PYTH Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PYTH',
    quoteCurrency: 'USDC',
    minBlockSize: 300,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZB: {
    code: 'ZB',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'HYPER',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'HYPER Future Linear - PRDX',
    longName: 'ZB - HYPER Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'HYPER',
    quoteCurrency: 'USDC',
    minBlockSize: 150,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZC: {
    code: 'ZC',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'DOGE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'DOGE Future Linear - PRDX',
    longName: 'ZC - DOGE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'DOGE',
    quoteCurrency: 'USDC',
    minBlockSize: 150,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZD: {
    code: 'ZD',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XLM',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XLM Future Linear - PRDX',
    longName: 'ZD - XLM Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XLM',
    quoteCurrency: 'USDC',
    minBlockSize: 50,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZE: {
    code: 'ZE',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LDO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LDO Future Linear - PRDX',
    longName: 'ZE - LDO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LDO',
    quoteCurrency: 'USDC',
    minBlockSize: 40,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZF: {
    code: 'ZF',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'LTC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'LTC Future Linear - PRDX',
    longName: 'ZF - LTC Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'LTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.25,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZG: {
    code: 'ZG',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ONDO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ONDO Future Linear - PRDX',
    longName: 'ZG - ONDO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ONDO',
    quoteCurrency: 'USDC',
    minBlockSize: 30,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZH: {
    code: 'ZH',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'MON',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'MON Future Linear - PRDX',
    longName: 'ZH - MON Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'MON',
    quoteCurrency: 'USDC',
    minBlockSize: 500,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZI: {
    code: 'ZI',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PENGU',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PENGU Future Linear - PRDX',
    longName: 'ZI - PENGU Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PENGU',
    quoteCurrency: 'USDC',
    minBlockSize: 1600,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZJ: {
    code: 'ZJ',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'ZEC',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ZEC Option Linear - PRDX',
    longName: 'ZJ - ZEC Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ZEC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.1,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
  },
  AE: {
    code: 'AE',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'RESOLV',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'RESOLV Future Linear - PRDX',
    longName: 'AE - RESOLV Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'RESOLV',
    quoteCurrency: 'USDC',
    minBlockSize: 600,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZK: {
    code: 'ZK',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'SPCX',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SPCX Future Linear - PRDX',
    longName: 'ZK - SPCX Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'SPCX',
    quoteCurrency: 'USDC',
    minBlockSize: 0.1,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZL: {
    code: 'ZL',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'JUP',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'JUP Future Linear - PRDX',
    longName: 'ZL - JUP Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'JUP',
    quoteCurrency: 'USDC',
    minBlockSize: 70,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZM: {
    code: 'ZM',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XPL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XPL Future Linear - PRDX',
    longName: 'ZM - XPL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XPL',
    quoteCurrency: 'USDC',
    minBlockSize: 170,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZN: {
    code: 'ZN',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'AVNT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'AVNT Future Linear - PRDX',
    longName: 'ZN - AVNT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'AVNT',
    quoteCurrency: 'USDC',
    minBlockSize: 150,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZO: {
    code: 'ZO',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'SEI',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'SEI Future Linear - PRDX',
    longName: 'ZO - SEI Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'SEI',
    quoteCurrency: 'USDC',
    minBlockSize: 300,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZP: {
    code: 'ZP',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ZRO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ZRO Future Linear - PRDX',
    longName: 'ZP - ZRO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ZRO',
    quoteCurrency: 'USDC',
    minBlockSize: 16,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZQ: {
    code: 'ZQ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'TRX',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'TRX Future Linear - PRDX',
    longName: 'ZQ - TRX Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'TRX',
    quoteCurrency: 'USDC',
    minBlockSize: 45,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZR: {
    code: 'ZR',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'XMR',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'XMR Future Linear - PRDX',
    longName: 'ZR - XMR Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'XMR',
    quoteCurrency: 'USDC',
    minBlockSize: 0.045,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZS: {
    code: 'ZS',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ENA',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ENA Future Linear - PRDX',
    longName: 'ZS - ENA Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ENA',
    quoteCurrency: 'USDC',
    minBlockSize: 170,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZT: {
    code: 'ZT',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'PUMP',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'PUMP Future Linear - PRDX',
    longName: 'ZT - PUMP Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'PUMP',
    quoteCurrency: 'USDC',
    minBlockSize: 10000,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZU: {
    code: 'ZU',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'CC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'CC Future Linear - PRDX',
    longName: 'ZU - CC Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'CC',
    quoteCurrency: 'USDC',
    minBlockSize: 100,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZV: {
    code: 'ZV',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'INJ',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'INJ Future Linear - PRDX',
    longName: 'ZV - INJ Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'INJ',
    quoteCurrency: 'USDC',
    minBlockSize: 3.1,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZX: {
    code: 'ZX',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'AAVE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'AAVE Future Linear - PRDX',
    longName: 'ZX - AAVE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'AAVE',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZY: {
    code: 'ZY',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ETHFI',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ETHFI Future Linear - PRDX',
    longName: 'ZY - ETHFI Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ETHFI',
    quoteCurrency: 'USDC',
    minBlockSize: 45,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  ZZ: {
    code: 'ZZ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'TRUMP',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'TRUMP Future Linear - PRDX',
    longName: 'ZZ - TRUMP Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'TRUMP',
    quoteCurrency: 'USDC',
    minBlockSize: 8,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  AA: {
    code: 'AA',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'TIA',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'TIA Future Linear - PRDX',
    longName: 'AA - TIA Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'TIA',
    quoteCurrency: 'USDC',
    minBlockSize: 40,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  AF: {
    code: 'AF',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'AVAX',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'AVAX Future Linear - PRDX',
    longName: 'AF - AVAX Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'AVAX',
    quoteCurrency: 'USDC',
    minBlockSize: 2.5,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  AC: {
    code: 'AC',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'NG',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'NG Future Linear - PRDX',
    longName: 'AC - NG Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'NG',
    quoteCurrency: 'USDC',
    minBlockSize: 5,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  AD: {
    code: 'AD',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'FARTCOIN',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'FARTCOIN Future Linear - PRDX',
    longName: 'AD - FARTCOIN Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'FARTCOIN',
    quoteCurrency: 'USDC',
    minBlockSize: 120,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  YA: {
    code: 'YA',
    venue: 'BLSH',
    kind: 'OPTION',
    currency: 'BTC',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'BTC Option Linear - BLSH',
    longName: 'YA - BTC Option - European - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.0005,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 0,
    ratioPrecision: 1,
    minContractIncrement: 0.0005,
    isNew: true,
    isDisabledForOb: true,
  },
  YB: {
    code: 'YB',
    venue: 'BLSH',
    kind: 'OPTION',
    currency: 'ETH',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'ETH Option Linear - BLSH',
    longName: 'YB - ETH Option - European - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.005,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 0,
    ratioPrecision: 1,
    minContractIncrement: 0.005,
    isDisabled: true,
    isDisabledForOb: true,
  },
  YC: {
    code: 'YC',
    venue: 'BLSH',
    kind: 'FUTURE',
    currency: 'BTC',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BTC Future Linear - BLSH',
    longName: 'YC - BTC Future - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'BTC',
    quoteCurrency: 'USDC',
    minBlockSize: 0.0001,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.0001,
    datedMinContractIncrement: 0.0005,
    datedMinBlockSize: 0.0005,
    isNew: true,
    isDisabledForOb: true,
  },
  YD: {
    code: 'YD',
    venue: 'BLSH',
    kind: 'FUTURE',
    currency: 'ETH',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ETH Future Linear - BLSH',
    longName: 'YD - ETH Future - Linear - Bullish',
    contractSize: 1,
    contractCurrency: 'ETH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.005,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.005,
    isNew: true,
    isDisabled: true,
    isDisabledForOb: true,
  },
  BA: {
    code: 'BA',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'APT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'APT Future Linear - PRDX',
    longName: 'BA - APT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'APT',
    quoteCurrency: 'USDC',
    minBlockSize: 22,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BC: {
    code: 'BC',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'ARB',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'ARB Future Linear - PRDX',
    longName: 'BC - ARB Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'ARB',
    quoteCurrency: 'USDC',
    minBlockSize: 160,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BG: {
    code: 'BG',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'AXS',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'AXS Future Linear - PRDX',
    longName: 'BG - AXS Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'AXS',
    quoteCurrency: 'USDC',
    minBlockSize: 13,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BH: {
    code: 'BH',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BCH',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BCH Future Linear - PRDX',
    longName: 'BH - BCH Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BCH',
    quoteCurrency: 'USDC',
    minBlockSize: 0.06,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BI: {
    code: 'BI',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'BERA',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'BERA Future Linear - PRDX',
    longName: 'BI - BERA Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'BERA',
    quoteCurrency: 'USDC',
    minBlockSize: 59,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BJ: {
    code: 'BJ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'CRCL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'CRCL Future Linear - PRDX',
    longName: 'BJ - CRCL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'CRCL',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BK: {
    code: 'BK',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'DOT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'DOT Future Linear - PRDX',
    longName: 'BK - DOT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'DOT',
    quoteCurrency: 'USDC',
    minBlockSize: 15,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BL: {
    code: 'BL',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'FIL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'FIL Future Linear - PRDX',
    longName: 'BL - FIL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'FIL',
    quoteCurrency: 'USDC',
    minBlockSize: 17,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BM: {
    code: 'BM',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'GOOGL',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'GOOGL Future Linear - PRDX',
    longName: 'BM - GOOGL Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'GOOGL',
    quoteCurrency: 'USDC',
    minBlockSize: 0.04,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BN: {
    code: 'BN',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'GRAM',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'GRAM Future Linear - PRDX',
    longName: 'BN - GRAM Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'GRAM',
    quoteCurrency: 'USDC',
    minBlockSize: 8,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BP: {
    code: 'BP',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'JTO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'JTO Future Linear - PRDX',
    longName: 'BP - JTO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'JTO',
    quoteCurrency: 'USDC',
    minBlockSize: 17,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 5,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BQ: {
    code: 'BQ',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'KAITO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'KAITO Future Linear - PRDX',
    longName: 'BQ - KAITO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'KAITO',
    quoteCurrency: 'USDC',
    minBlockSize: 22,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BR: {
    code: 'BR',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'kBONK',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'kBONK Future Linear - PRDX',
    longName: 'BR - kBONK Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'kBONK',
    quoteCurrency: 'USDC',
    minBlockSize: 2900,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BS: {
    code: 'BS',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'kPEPE',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'kPEPE Future Linear - PRDX',
    longName: 'BS - kPEPE Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'kPEPE',
    quoteCurrency: 'USDC',
    minBlockSize: 5200,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BT: {
    code: 'BT',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'kSHIB',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'kSHIB Future Linear - PRDX',
    longName: 'BT - kSHIB Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'kSHIB',
    quoteCurrency: 'USDC',
    minBlockSize: 2900,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 6,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BV: {
    code: 'BV',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'META',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'META Future Linear - PRDX',
    longName: 'BV - META Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'META',
    quoteCurrency: 'USDC',
    minBlockSize: 0.03,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BW: {
    code: 'BW',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'MORPHO',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'MORPHO Future Linear - PRDX',
    longName: 'BW - MORPHO Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'MORPHO',
    quoteCurrency: 'USDC',
    minBlockSize: 6.4,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  BY: {
    code: 'BY',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'MSFT',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'MSFT Future Linear - PRDX',
    longName: 'BY - MSFT Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'MSFT',
    quoteCurrency: 'USDC',
    minBlockSize: 0.04,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CA: {
    code: 'CA',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'MSTR',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'MSTR Future Linear - PRDX',
    longName: 'CA - MSTR Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'MSTR',
    quoteCurrency: 'USDC',
    minBlockSize: 0.2,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 2,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CB: {
    code: 'CB',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'OP',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'OP Future Linear - PRDX',
    longName: 'CB - OP Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'OP',
    quoteCurrency: 'USDC',
    minBlockSize: 130,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CD: {
    code: 'CD',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'STRK',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'STRK Future Linear - PRDX',
    longName: 'CD - STRK Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'STRK',
    quoteCurrency: 'USDC',
    minBlockSize: 410,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CE: {
    code: 'CE',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'UNI',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'UNI Future Linear - PRDX',
    longName: 'CE - UNI Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'UNI',
    quoteCurrency: 'USDC',
    minBlockSize: 4.4,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CG: {
    code: 'CG',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'VVV',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'VVV Future Linear - PRDX',
    longName: 'CG - VVV Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'VVV',
    quoteCurrency: 'USDC',
    minBlockSize: 0.98,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CH: {
    code: 'CH',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'WIF',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'WIF Future Linear - PRDX',
    longName: 'CH - WIF Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'WIF',
    quoteCurrency: 'USDC',
    minBlockSize: 72,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CI: {
    code: 'CI',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'WLD',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'WLD Future Linear - PRDX',
    longName: 'CI - WLD Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'WLD',
    quoteCurrency: 'USDC',
    minBlockSize: 30,
    strategies: 'all',
    quantityPrecision: 1,
    pricePrecision: 4,
    ratioPrecision: 1,
    minContractIncrement: 0.1,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CJ: {
    code: 'CJ',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'CL',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'CL Option Linear - PRDX',
    longName: 'CJ - CL Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'CL',
    quoteCurrency: 'USDC',
    minBlockSize: 1,
    strategies: 'all',
    quantityPrecision: 0,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 1,
    isNew: true,
    isDisabledForOb: true,
  },
  CK: {
    code: 'CK',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'US100',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'US100 Option Linear - PRDX',
    longName: 'CK - US100 Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'US100',
    quoteCurrency: 'USDC',
    minBlockSize: 0.01,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
  },
  CM: {
    code: 'CM',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'US100',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'US100 Future Linear - PRDX',
    longName: 'CM - US100 Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'US100',
    quoteCurrency: 'USDC',
    minBlockSize: 0.0005,
    strategies: 'all',
    quantityPrecision: 4,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.0001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  CN: {
    code: 'CN',
    venue: 'PRDX',
    kind: 'OPTION',
    currency: 'US500',
    contractType: 'EUROPEAN',
    marginType: 'LINEAR',
    shortName: 'US500 Option Linear - PRDX',
    longName: 'CN - US500 Option - European - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'US500',
    quoteCurrency: 'USDC',
    minBlockSize: 0.01,
    strategies: 'all',
    quantityPrecision: 2,
    pricePrecision: 3,
    ratioPrecision: 1,
    minContractIncrement: 0.01,
    isNew: true,
    isDisabledForOb: true,
  },
  CO: {
    code: 'CO',
    venue: 'PRDX',
    kind: 'FUTURE',
    currency: 'US500',
    contractType: 'LINEAR',
    marginType: 'LINEAR',
    shortName: 'US500 Future Linear - PRDX',
    longName: 'CO - US500 Future - Linear - Paradex',
    contractSize: 1,
    contractCurrency: 'US500',
    quoteCurrency: 'USDC',
    minBlockSize: 0.002,
    strategies: 'all',
    quantityPrecision: 3,
    pricePrecision: 1,
    ratioPrecision: 1,
    minContractIncrement: 0.001,
    isNew: true,
    isDisabledForOb: true,
    isHedgeDisabled: true,
  },
  // --- END GENERATED PRODUCT CONFIG (paradex-products) ---
};

export const PRODUCTS: Readonly<Record<string, Product>> = PRODUCTS_STRICT;
